function formatHairRegion(region) {
  if (!region || region === 'full' || region === 'all') return 'Full head';
  return String(region).replace(/_/g, ' ');
}

export function buildHairStyleHistoryDetails({
  label,
  source,
  styleId = null,
  colorId = null,
  colorRegion = null,
  colorName = '',
}) {
  const name = String(label || 'Hairstyle').trim() || 'Hairstyle';
  const detailLines = [];
  const isColorApply =
    source === 'color' || source === 'recommended' || (Boolean(colorId) && source !== 'style' && source !== 'custom');

  if (isColorApply) {
    detailLines.push(`Hair color: ${name}`);
    detailLines.push(`Region: ${formatHairRegion(colorRegion)}`);
    return {
      label: name,
      detailTitle: name,
      detailLines,
    };
  }

  detailLines.push(`Hairstyle: ${name}`);
  if (colorName) detailLines.push(`Hair color: ${colorName}`);
  if (styleId) detailLines.push(`Style: ${name}`);

  return {
    label: name,
    detailTitle: name,
    detailLines,
  };
}
